<script setup lang="ts">
// A control turned off because the node lacks its feature (DECISIONS
// 2026-10-17 "nodes behind central"): says so with the node's version and
// the first version central keeps that has it; a superadmin gets the
// node's update from here. Shown with v-if="!hasFeature(node.features, …)";
// TestFeatureGatesListed reads its feature too.
import { computed } from 'vue'
import { useNode } from '../store'
import { needsNewer } from '../features'

const props = defineProps<{ feature: string }>()
const node = useNode()
const text = computed(() => needsNewer(node.info?.version, node.firstVersions?.[props.feature]))
</script>

<template>
    <div class="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-fg-2" data-test="needs-newer">
        <span>{{ text }}</span>
        <button
            v-if="node.user?.superadmin"
            class="btn-ghost px-1.5 py-0 text-xs"
            data-test="needs-newer-update"
            @click="node.showUpdate = true"
        >
            Update…
        </button>
    </div>
</template>
